import { useAuth0 } from '@auth0/auth0-react';
import { Button } from 'react-bootstrap';
import './Authbuttons.css';

function LoginButton() {
  const { loginWithRedirect } = useAuth0();

  return (
    <Button
      onClick={() => loginWithRedirect()}
      className="auth-btn login-btn"
    >
      Log In
    </Button>
  );
}

export default LoginButton;